// user
export const USER_SET_TOKEN = 'USER_SET_TOKEN';
export const USER_SET_USERINFO = 'USER_SET_USERINFO';
export const USER_SET_FUNCTIONLIST = 'USER_SET_FUNCTIONLIST';
export const USER_CLEAR_USERINFO = 'USER_CLEAR_USERINFO';
export const USER_LOGOUT_REQUEST = 'USER_LOGOUT_REQUEST';
export const USER_LOGOUT_SUCCESS = 'USER_LOGOUT_SUCCESS';
export const USER_LOGOUT_FAIL = 'USER_LOGOUT_FAIL';

export const USER_LOGIN_REQUEST = 'USER_LOGIN_REQUEST';
export const USER_LOGIN_SUCCESS = 'USER_LOGIN_SUCCESS';
export const USER_LOGIN_FAIL = 'USER_LOGIN_FAIL';
